import { render, staticRenderFns } from "./HeaderSteps.vue?vue&type=template&id=8e0fa830&lang=pug"
import script from "./HeaderSteps.vue?vue&type=script&lang=js"
export * from "./HeaderSteps.vue?vue&type=script&lang=js"
import style0 from "./HeaderSteps.vue?vue&type=style&index=0&id=8e0fa830&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports